import * as yup from "yup";

export const userInfoValidator = yup.object().shape({
  // @TODO: Translation.
  email: yup.string().email().required("Username error"),
  first_name: yup.string().required("First name error"),
  last_name: yup.string().required("Last name error"),
});

export const taxRateValidator = yup.object().shape({
  name: yup.string().required(),
  percentage: yup.number().required(),
});

export const overdueRemindersValidator = yup.object().shape({
  invoice_overdue_reminders_send_first: yup.number().required(),
  invoice_overdue_reminders_first_message: yup.string(),
  invoice_overdue_reminders_send_every: yup.number(),
});

export const searchConfigValidator = yup.object().shape({
  hosts: yup.string().required(),
  shards: yup.number().required(),
  replicas: yup.number().required(),
  user: yup.string(),
  password: yup.string(),
  path_to_certificate: yup.string(),
});

export const pusherConfigValidator = yup.object().shape({
  app_id: yup.string().required(),
  app_key: yup.string().required(),
  app_cluster: yup.string().required(),
  app_secret: yup.string().required(),
});

export const outgoingEmailValidator = yup.object().shape({
  sender_name: yup.string(),
  sender_email: yup.string().email().required(),
  smtp_username: yup.string().required(),
  smtp_password: yup.string().required(),
  smtp_host: yup.string().required(),
  smtp_security: yup.string().oneOf(["auto", "tls", "ssl", "off"]).required(),
  smtp_port: yup.number().required(),
  smtp_verify_certificate: yup.bool(),
});

export const inboundEmailValidator = yup.object().shape({
  imap_username: yup.string().required(),
  imap_password: yup.string().required(),
  imap_host: yup.string().required(),
  imap_security: yup.string().oneOf(["auto", "tls", "ssl", "off"]).required(),
  imap_port: yup.number().required(),
  imap_verify_certificate: yup.bool(),
  imap_mailbox: yup.string().required(),
});
